import React from 'react';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="flex min-h-screen flex-col bg-white" data-id="element-111">
      <Navigation data-id="element-112" />
      <main className="flex-grow" data-id="element-113">{children}</main>
      <Footer data-id="element-114" />
    </div>;
}